import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import CategoryFilterEdit from '../Utils/CategoryFilterEdit';
import { withAuth } from '../AuthContext';
import { Link, withRouter } from 'react-router-dom';
import Button from "../Utils/Button";
import Notification from "../Utils/Notification";
import {SUCCESS} from "../../utils/constants";

class HostSignup extends Component {
    constructor(props) {
        super(props);
        const u = this.props.auth.user;

        this.state = {
            user: {
                addressLine1: u.addressLine1,
                addressLine2: u.addressLine2,
                city: u.city,
                locationId: u.locationId,
                county: u.county,
                postcode: u.postcode,
            },
            place: { hostPrice: 0, placePhotoDescription: '', inviteGuest: 1 },
            filters: [],
            allFilters: [],
            filterOptions: [],
            filterOptionIds: [10,13,19,22,25,36],
            cities: [],
            currencies: [],
            valid: true,
            errorText : '',
            file: null,
            loading: false
        };

        this.handlePlaceInputChange = this.handlePlaceInputChange.bind(this);
        this.handleUserInputChange = this.handleUserInputChange.bind(this);
        this.handlePlaceTypeChange = this.handlePlaceTypeChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getCities = this.getCities.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleGuestChange = this.handleGuestChange.bind(this);
        this.handlePhotoUpload = this.handlePhotoUpload.bind(this);

    }

    componentDidMount() {
        if (this.props.auth.user.countryId) {
            this.getCities(this.props.auth.user.countryId);
        }

        axios
            .get('/api/filters')
            .then(response => {
                this.setState({ allFilters: response.data });
            })
            .catch(function(error) {
                console.log('Request failure: ', error);
            });

        axios
            .get('/api/filteroptions')
            .then(response => {
                this.setState({ filterOptions: response.data });
            })
            .catch(function(error) {
                console.log('Request failure: ', error);
            });

        axios
            .get('/api/currencies')
            .then(response => {
                this.setState({
                    currencies: response.data.map(c => {
                        return { value: c.id, label: c.ISO };
                    })
                });
            })
            .catch(function(error) {
                console.log('Request failure: ', error);
            });
    }

    getCities(countryId) {
        axios
            .get(`/api/cities/${countryId}`)
            .then(response => {
                this.setState({
                    cities: response.data.map(c => {
                        return { value: c.id, label: c.city };
                    })
                });
            })
            .catch(function(error) {
                console.log('Request failure: ', error);
            });
    }

    handlePlaceInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState(prevState => {
            prevState.place[name] = value;
            return prevState;
        });
    }

    handlePhotoUpload(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleUserInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState(prevState => {
            prevState.user[name] = value;
            return prevState;
        });
    }

    handleCityChange({ value }) {
        const city = this.state.cities.find(c => c.value === value);

        this.setState(prevState => {
            prevState.user.locationId = value;
            prevState.user.city = city.label;
            return prevState;
        });
    }

    handleCurrencyChange({ value }) {
        this.setState(prevState => {
            prevState.place.currencyId = value;
            return prevState;
        });
    }

    handlePlaceTypeChange({ label }) {
        this.setState(prevState => {
            prevState.place.typePlace = label;
            return prevState;
        });
    }

    handleGuestChange({ value }) {
        this.setState(prevState => {
            prevState.place.inviteGuest = value;
            return prevState;
        });
    }

    handleFilterChange(event) {
        const target = event.target;


        if (target.type === 'checkbox') {
            if (target.checked) {
                // add the checked filter's id to state
                this.setState(prevState => {
                    prevState.filterOptionIds.push(parseInt(target.value));
                    prevState.place.filterOptionId = prevState.filterOptionIds.toString();
                    return prevState;
                });
            } else {
                // remove the unchecked filter's id from state
                this.setState(prevState => {
                    let index = prevState.filterOptionIds.indexOf(parseInt(target.value));
                    prevState.filterOptionIds.splice(index, 1);
                    prevState.place.filterOptionId = prevState.filterOptionIds.toString();
                    return prevState;
                });
            }
        } else if (target.type === 'radio') {
            // find the object containing all info about the selected radio filter option
            const selected = this.state.filterOptions.find(
                (fo, i) => fo.id == target.value
            );
            // find all filters options belonging to the radio filter option's 'group'
            const otherFilters = this.state.filterOptions.filter(
                fo => fo.filterId == selected.filterId
            );

            this.setState(prevState => {
                // remove all other filter options in the group from state
                otherFilters.forEach((f, i) => {
                    let index = prevState.filterOptionIds.indexOf(f.id);
                    index > -1 ? prevState.filterOptionIds.splice(index, 1) : null;
                });

                // add the newly selected filter option to state
                prevState.filterOptionIds.push(parseInt(target.value));
                prevState.place.filterOptionId = prevState.filterOptionIds.toString();
                return prevState;
            });
        }
    }

    handleSubmit() {
        this.setState({ loading: true });
        // UX could be improved here...
        if (this.state.hostPrice < 0) {
            this.setState({
                valid: false,
                errorText: 'Please enter a valid price per night per room'
            });
            return;
        }

        const headers = {
            'content-type': 'multipart/form-data'
        };

        const formData = new FormData();

        formData.append('file', this.state.file);
        formData.append('user', JSON.stringify(this.state.user));
        formData.append('place', JSON.stringify(this.state.place));
        formData.append('filters', JSON.stringify(this.state.filterOptionIds));

        axios
            .post('/api/register-host', formData, headers)
            .then(response => {
                Notification({
                    type: SUCCESS,
                    message: 'Your request has been sent successfully'
                })
                this.props.auth.handleLogin(response.data);
                this.props.history.push(`/dashboard/place/${response.data.placeID}/upload-proof`);
            }).catch((e) => {
                Notification({
                    data: e
                })
            }).finally(() => {
                this.setState({ loading: false });
            });
    }

    render() {
        const u = this.props.auth.user;

        const p = this.state.place;

        const citySelected = this.state.cities.find(
            c => c.value === this.state.user.locationId
        );
        const currencySelected = this.state.currencies.find(
            c => c.value === this.state.place.currencyId
        );

        const typesOfPlaces = [
            { value: 0, label: 'Apartment' },
            { value: 1, label: 'House' },
            { value: 2, label: 'Other' }
        ];

        const typeSelected = typesOfPlaces.find(
            t => t.label === this.state.place.typePlace
        );

        const filters = this.state.allFilters
            .filter(f => f.filterType !== 'range')
            .map(f => {
                const filterOptions = this.state.filterOptions
                    .filter(o => o.filterId === f.id)
                    .map(o => {
                        return {
                            name: o.id,
                            label: o.filterOption,
                            position: o.position,
                            checked: this.state.filterOptionIds.includes(o.id)
                        };
                    })
                    .sort((a, b) => a.position - b.position);

                return (
                    <CategoryFilterEdit
                        key={f.display}
                        label={f.display}
                        type={f.filterType === 'radiobutton' ? 'radio' : f.filterType}
                        handleChange={this.handleFilterChange}
                        options={filterOptions}
                        checked={f.checked}
                    />
                );
            });

        const customStyles = {
            control: (base, state) => ({
                ...base,
                background: '#ffffff',
                color: '#8d95a6',
                height: '58px',
                fontSize: '16px',
                paddingLeft: '15px',
                width: '100%',
                marginBottom: '10px',
                outline: 'none',
                flexWrap: 'nowrap',
                border: 'none'
            })
        };

        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="title">Become a host</h3>
                                <div id="edit-place">
                                    <div id="message" />
                                    <form
                                        method="POST"
                                        action="/"
                                        name="myForm"
                                        aria-label="Edit Place"
                                        onSubmit={event => {
                                            event.preventDefault();
                                            this.handleSubmit();
                                            return false;
                                        }}>
                                        <input
                                            type="hidden"
                                            name="csrf-token"
                                            value={window.Laravel.csrfToken}
                                        />
                                        <div className="col-12  form-group">
                                            <label>Address line 1</label>
                                            <input
                                                className="form-control"
                                                id="addressLine1"
                                                type="text"
                                                name="addressLine1"
                                                required
                                                autoFocus
                                                value={this.state.user.addressLine1}
                                                onChange={this.handleUserInputChange}
                                            />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Address line 2</label>
                                            <input
                                                className="form-control"
                                                id="addressLine2"
                                                type="text"
                                                name="addressLine2"
                                                autoFocus
                                                value={this.state.user.addressLine2}
                                                onChange={this.handleUserInputChange}
                                            />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>City</label>

                                            <Select
                                                id="city"
                                                name="city"
                                                styles={customStyles}
                                                value={citySelected}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={false}
                                                isRtl={false}
                                                isSearchable={true}
                                                required
                                                options={this.state.cities}
                                                onChange={this.handleCityChange}
                                            />
                                            <p>
                                                If your city or town is not listed, please contact us at
                                                hello@thefreebirdclub.com
                                            </p>
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>State or county</label>
                                            <input
                                                className="form-control"
                                                id="county"
                                                type="text"
                                                name="county"
                                                required
                                                autoFocus
                                                value={this.state.user.county}
                                                onChange={this.handleUserInputChange}
                                            />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Postcode</label>
                                            <input
                                                className="form-control"
                                                id="postcode"
                                                type="text"
                                                name="postcode"
                                                autoFocus
                                                value={this.state.user.postcode}
                                                onChange={this.handleUserInputChange}
                                            />
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Currency</label>
                                            <Select
                                                id="currencyId"
                                                name="currencyId"
                                                styles={customStyles}
                                                value={currencySelected}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={false}
                                                isRtl={false}
                                                isSearchable={true}
                                                options={this.state.currencies}
                                                required
                                                onChange={this.handleCurrencyChange}
                                            />
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Price per night per room</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="hostPrice"
                                                min="1"
                                                step="1"
                                                required
                                                autoFocus
                                                value={this.state.place.hostPrice}
                                                onChange={this.handlePlaceInputChange}
                                            />
                                            <p>
                                                This is up to you. You may wish to consider B&B rates in
                                                your area to get an idea. We advise starting with a low
                                                price initially to attract your first guests, you can
                                                always increase later. Round figures are required, i.e.
                                                '45'. 12% Freebird Fee (plus VAT) will be added on top
                                                of this price for guests.
                                            </p>
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Property type</label>
                                            <Select
                                                id="typePlace"
                                                name="typePlace"
                                                styles={customStyles}
                                                value={typeSelected}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={false}
                                                isRtl={false}
                                                isSearchable={true}
                                                required
                                                options={typesOfPlaces}
                                                onChange={this.handlePlaceTypeChange}
                                            />
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Place description</label>
                                            <textarea
                                                id="placeDescription"
                                                name="placeDescription"
                                                rows="5"
                                                style={{ minWidth: '100%' }}
                                                required
                                                autoFocus
                                                placeholder="Describe the property itself (e.g. a two bedroom apartment with ensuite bathrooms and large kitchen, etc.)"
                                                value={this.state.place.placeDescription}
                                                onChange={this.handlePlaceInputChange}
                                            />
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Place photo</label>
                                            <input className='btn btn-primary' type="file" onChange={this.handlePhotoUpload} />
                                            <p>
                                                This will be the primary photo of your place listing;
                                                you will have the opportunity to add more photos under
                                                "Manage Photos" PNG, GIF, JPEG or JPG smaller than 6MB
                                                are allowed to upload
                                            </p>
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Place photo caption</label>

                                            <input
                                                className="form-control"
                                                type="text"
                                                name="placePhotoDescription"
                                                required
                                                autoFocus
                                                placeholder="(e.g. living room)"
                                                value={this.state.place.placePhotoDescription}
                                                onChange={this.handlePlaceInputChange}
                                            />
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Location description</label>
                                            <textarea
                                                id="locationDescription"
                                                name="locationDescription"
                                                rows="5"
                                                style={{ minWidth: '100%' }}
                                                required
                                                autoFocus
                                                placeholder="Describe the area where this property is located (e.g. local amenities, transport links, climate, etc.)"
                                                value={this.state.place.locationDescription}
                                                onChange={this.handlePlaceInputChange}
                                            />
                                            <hr />
                                        </div>
                                        <div className="col-12  form-group">
                                            <label>Languages spoken</label>
                                            <textarea
                                                id="language"
                                                name="language"
                                                rows="5"
                                                style={{ minWidth: '100%' }}
                                                required
                                                autoFocus
                                                placeholder="Describe the languages spoken by the residents (e.g. fluent Spanish and a little French)"
                                                value={this.state.place.language}
                                                onChange={this.handlePlaceInputChange}
                                            />
                                            <hr />
                                        </div>
                                        {filters}
                                        <div className="submit-btn">
                                            <Button
                                                type="submit"
                                                color="primary"
                                                icon="fa fa-save"
                                                loading={this.state.loading}
                                            >
                                                Save Changes
                                            </Button>
                                            <Link to="/dashboard" className="btn btn-warning text-decoration-none ml-2">
                                                Return
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(withAuth(HostSignup));
